{
	"whiteboardSolidHeader": "confluence_frontend_solid_whiteboard_header",
	"whiteboardOptOut": "whiteboards_compliance_opt_out",
	"aiSmartButton": "ai-smart-button-team-25",
	"digitalTeammate": "cc-ai-whiteboards-enable-digital-teammate",
	"presence": "confluence_team_presence_whiteboard"
}
